<template>
  <v-card height="800px">
    <v-card-title>
      <span class="headline">Gérer mots clés</span>
    </v-card-title>
    <v-card-subtitle>
      <p style="word-break: keep-all">
        <span style="color: #757575"
          >{{ getPollenFamille }}
          >
          {{ getPollenGenre }}
          >
        </span>
        {{ activePollen.espece }}
      </p>
    </v-card-subtitle>
    <v-card-text>
      <v-container>
        <v-row>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header
                >Symétrie et forme</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-container>
                  <v-row>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="m in getMotclePlus
                          .filter((m) => m.id_caract === 6)
                          .slice(
                            0,
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 6)
                                .length / 2
                            )
                          )"
                        v-bind:key="m.id_motcle"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="m in getMotclePlus
                          .filter((m) => m.id_caract === 6)
                          .slice(
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 6)
                                .length / 2
                            )
                          )"
                        v-bind:key="m.id_motcle"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header
                >Aperture - Nombre et type</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-container>
                  <v-row>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="m in getMotclePlus
                          .filter((m) => m.id_caract === 5)
                          .slice(
                            0,
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 5)
                                .length / 2
                            )
                          )"
                        v-bind:key="m.id_motcle"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="m in getMotclePlus
                          .filter((m) => m.id_caract === 5)
                          .slice(
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 5)
                                .length / 2
                            )
                          )"
                        v-bind:key="m.id_motcle"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header
                >Aperture - Ectoaperture</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-container>
                  <v-row>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="m in getMotclePlus
                          .filter((m) => m.id_caract === 3)
                          .slice(
                            0,
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 3)
                                .length / 2
                            )
                          )"
                        v-bind:key="m.id_motcle"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="m in getMotclePlus
                          .filter((m) => m.id_caract === 3)
                          .slice(
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 3)
                                .length / 2
                            )
                          )"
                        v-bind:key="m.id_motcle"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header
                >Aperture - Endoaperture</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-container>
                  <v-row>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="(m, ii) in getMotclePlus
                          .filter((m) => m.id_caract === 4)
                          .slice(
                            0,
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 4)
                                .length / 2
                            )
                          )"
                        v-bind:key="ii"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="(m, ii) in getMotclePlus
                          .filter((m) => m.id_caract === 4)
                          .slice(
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 4)
                                .length / 2
                            )
                          )"
                        v-bind:key="ii"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header
                >Exine - Ectexine</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-container>
                  <v-row>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="m in getMotclePlus
                          .filter((m) => m.id_caract === 2)
                          .slice(
                            0,
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 2)
                                .length / 2
                            )
                          )"
                        v-bind:key="m.id_motcle"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="m in getMotclePlus
                          .filter((m) => m.id_caract === 2)
                          .slice(
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 2)
                                .length / 2
                            )
                          )"
                        v-bind:key="m.id_motcle"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header
                >Exine - Endexine</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-container>
                  <v-row>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="m in getMotclePlus
                          .filter((m) => m.id_caract === 1)
                          .slice(
                            0,
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 1)
                                .length / 2
                            )
                          )"
                        v-bind:key="m.id_motcle"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <v-row
                        v-for="m in getMotclePlus
                          .filter((m) => m.id_caract === 1)
                          .slice(
                            Math.ceil(
                              getMotclePlus.filter((m) => m.id_caract === 1)
                                .length / 2
                            )
                          )"
                        v-bind:key="m.id_motcle"
                      >
                        <v-checkbox
                          :label="m.valeur"
                          color="#2B2118"
                          @change="(e) => changeMotcle(e, m)"
                          :input-value="m.caracterise"
                          hide-details
                        ></v-checkbox>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>

        <v-row><v-divider></v-divider></v-row>
        <v-row>
          <v-col>
            <p>
              Si vous ne trouvez pas la mot-clef dans la liste, vous pouvez
              ajouter une nouvelle mot-clef ci dessous.
            </p>
            <p>
              Sélectionner une caractéristique et écrire le nom de la nouvelle
              mot-clef. Appuyer sur "Ajouter à la liste".
            </p></v-col
          >
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" md="4">
            <v-select
              :items="
                Object.keys(caract_dict).map((x) => {
                  return {
                    id_caract: x,
                    nom_caract: caract_dict[x],
                  };
                })
              "
              item-text="nom_caract"
              item-value="id_caract"
              label="Caractéristique"
              v-model="id_new_caract"
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              v-model="new_motcle"
              label="Nom Mot-clef"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-btn
              :disabled="!id_new_caract || !new_motcle"
              @click="submitMotcle()"
            >
              <v-icon left>mdi-plus-circle</v-icon>
              Ajouter à la liste
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="#2B2118" dark @click="closeDialog"> Retour </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CrudEspeceManageKeywords2",
  data() {
    return {
      isCheckbox: true,
      dialogDelete: false,
      caract_dict: {
        1: "Exine - Endexine",
        2: "Exine - Ectexine",
        3: "Aperture - Ectoaperture",
        4: "Aperture - Endoaperture",
        5: "Aperture - Nombre et type",
        6: "Symétrie et forme",
      },
      dialog: false,
      id_new_caract: null,
      new_motcle: "",
      editedIndex: -1,
      editedItem: {
        id_caract: "",
        id_motcle: "",
        id_pollen: "",
        id: "",
      },
      defaultItem: {
        id_caract: "",
        id_motcle: "",
        id_pollen: "",
        id: "",
      },
      headers: [
        {
          text: "Caractéristique",
          align: "start",
          value: "nom_caract",
        },
        { text: "Mot-clef", value: "nom_motcle" },
        { text: "Actions", value: "actions", align: "right", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getManageKeywordsDetail",
      "getPollensAll",
      "getMotcle",
      "getFamille",
      "getGenre",
      "getCaracterise",
      "getAdminActivePollenIndex",
      "getCaractGroup",
    ]),
    activePollen() {
      return this.getPollensAll[this.getAdminActivePollenIndex];
    },
    getPollenCaracterise() {
      return this.activePollen.id_pollen in this.getCaractGroup ? this.getCaractGroup[this.activePollen.id_pollen] : [];
    },
    getMotclePlus() {
      return this.getMotcle
        .map((m) => {
          return {
            ...m,
            is_active:
              this.getPollenCaracterise.findIndex((c) => c === m.id_motcle) > 0,
            caracterise: this.getCaracterise.find(
              (c) =>
                c.id_motcle === m.id_motcle &&
                c.id_pollen === this.activePollen.id_pollen
            ),
          };
        })
        .sort((a, b) =>
          a.valeur.toLowerCase() > b.valeur.toLowerCase() ? 1 : -1
        );
    },
    getPollenFamille() {
      return this.getFamille.filter(
        (f) => f.id_famille === this.activePollen.id_famille
      )[0].nom_famille;
    },
    getPollenGenre() {
      return this.getGenre.filter(
        (f) => f.id_genre === this.activePollen.id_genre
      )[0].nom_genre;
    },
    getPollenEndexine() {
      return this.getPollenCaracterise
        .filter((c) => c.id_caract === 1)
        .map((x) => x.id_motcle);
    },
    getPollenEctexine() {
      return this.getPollenCaracterise
        .filter((c) => c.id_caract === 2)
        .map((x) => x.id_motcle);
    },
  },
  methods: {
    ...mapActions(["addCaracterise", "deleteCaracterise", "addMotcle"]),
    setOpenDetail(isOpen) {
      this.$store.commit("setManageKeywordsDialog", isOpen);
    },
    deleteItemConfirm() {
      this.deleteCaracterise(this.editedItem.id);
      this.closeDelete();
    },
    deleteItem(item) {
      this.editedIndex = this.getCaracterise.findIndex(
        (gen) => gen.id === item.id
      );
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDialog() {
      this.setOpenDetail(false);
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.editedIndex > -1) {
        // DO SOMETHING
      } else {
        this.editedItem.id_pollen = this.activePollen.id_pollen;
        this.addCaracterise(this.editedItem);
      }
      this.close();
    },
    submitMotcle() {
      const inputData = {
        id_caract: this.id_new_caract,
        valeur: this.new_motcle,
      };
      this.addMotcle(inputData);
      this.id_new_caract = null;
      this.new_motcle = "";
    },
    changeMotcle(e, m) {
      if (e) {
        this.addCaracterise({
          id_caract: m.id_caract,
          id_motcle: m.id_motcle,
          id_pollen: this.activePollen.id_pollen,
        });
      } else {
        this.deleteCaracterise(m.caracterise.id);
      }
    },
  },
};
</script>

<style>
</style>